/**
 * Mes de trabajo compartido en Honorarios / Cobranza.
 * Persiste al cambiar de pestaña (Control, Notas del mes, etc.).
 */
const STORAGE_KEY = "visor:honorarios_work_period";

export function currentHonorariosPeriod() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
}

export function normalizeHonorariosPeriod(value) {
  const raw = String(value || "").trim();
  if (/^\d{4}-\d{2}$/.test(raw)) return raw;
  return currentHonorariosPeriod();
}

export function splitHonorariosPeriod(period) {
  const norm = normalizeHonorariosPeriod(period);
  const [year, month] = norm.split("-");
  return { year, month };
}

export function joinHonorariosPeriod(year, month) {
  const y = String(year || "").trim();
  const m = String(month || "").padStart(2, "0");
  if (!/^\d{4}$/.test(y) || !/^(0[1-9]|1[0-2])$/.test(m)) {
    return currentHonorariosPeriod();
  }
  return `${y}-${m}`;
}

export function readStoredHonorariosWorkPeriod() {
  try {
    if (typeof localStorage === "undefined") return currentHonorariosPeriod();
    return normalizeHonorariosPeriod(localStorage.getItem(STORAGE_KEY));
  } catch {
    return currentHonorariosPeriod();
  }
}

export function writeStoredHonorariosWorkPeriod(period) {
  const norm = normalizeHonorariosPeriod(period);
  try {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_KEY, norm);
    }
  } catch {
    /* ignore quota / private mode */
  }
  return norm;
}

export const HONORARIOS_WORK_PERIOD_STORAGE_KEY = STORAGE_KEY;
